/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FileType {
    LEAD_FILE = 'LeadFile',
    ACCOUNT_PHOTO = 'AccountPhoto',
}
